import React, { JSX } from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Box, Button, Container, Typography } from '@mui/material';

export function HowItWorksCta(props: { onGetStarted: () => void }): JSX.Element {
  return (
    <Box sx={{ backgroundColor: 'primary.main', color: 'primary.contrastText', py: 6 }}>
      <Container>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            maxWidth: 600,
            mx: 'auto',
          }}
        >
          <Typography variant="h3" component="h2" gutterBottom sx={{ color: 'white' }}>
            Ready to try Backstory?
          </Typography>
          <Typography variant="h6" sx={{ mb: 4 }}>
            Experience the future of job matching and resume generation today.
          </Typography>
          <Button
            variant="contained"
            size="large"
            startIcon={<PlayArrowIcon />}
            onClick={props.onGetStarted}
            sx={{
              backgroundColor: 'action.active',
              color: 'background.paper',
              fontWeight: 'bold',
              px: 4,
              py: 1.5,
              '&:hover': { backgroundColor: 'action.active', opacity: 0.9 },
            }}
          >
            Get Started Now
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
